import { FitBar, FitLine } from "@/components/posting/parts";
import type { ToolFit } from "@/lib/tools/check";
import type { TailorSlot } from "./TailorBlock";

/**
 * The count and Tailor on a phone, held under the header while the resume
 * is edited. It reaches the page's edges past the frame's own padding. A
 * closed job has no Tailor, so `tailor` is null there.
 */
export default function ResultStrip({ fit, tailor }: { fit: ToolFit; tailor: TailorSlot }) {
    return (
        <div
            data-testid="result-strip"
            className="sticky top-16 z-10 -mx-4 -mt-5 mb-5 flex items-center gap-3 border-b border-line bg-card px-4 py-2 shadow-card min-[761px]:hidden"
        >
            <div className="flex min-w-0 flex-1 flex-col gap-[5px] whitespace-nowrap">
                {fit.asked === 0 ? (
                    <span className="text-ui text-fg-muted">No skills to count</span>
                ) : (
                    <>
                        <FitLine covered={fit.covered} asked={fit.asked}>
                            keywords
                        </FitLine>
                        <FitBar share={fit.share} height={6} />
                    </>
                )}
            </div>
            {tailor?.("strip")}
        </div>
    );
}
